import { X } from "lucide-react";
import * as React from "react";
import { useEffect } from "react";

import { dismissToast, useToast } from "../../data/toast";

// How long a toast stays up before dismissing itself.
export const TOAST_MS = 6000;

// Renders the current toast (see src/data/toast.ts) above the bottom nav.
const ToastHost: React.FC = () => {
  const toast = useToast();

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => dismissToast(toast.id), TOAST_MS);
    return () => clearTimeout(timer);
  }, [toast]);

  return (
    <output className="toast-region" aria-live="polite">
      {toast && (
        <span className="toast" key={toast.id}>
          <span className="toast-message">{toast.message}</span>
          {toast.action && (
            <button
              type="button"
              className="toast-action"
              onClick={() => {
                dismissToast(toast.id);
                toast.action!.run();
              }}
            >
              {toast.action.label}
            </button>
          )}
          <button
            type="button"
            className="toast-close"
            aria-label="Dismiss"
            onClick={() => dismissToast(toast.id)}
          >
            <X size="1em" aria-hidden="true" />
          </button>
        </span>
      )}
    </output>
  );
};

export default ToastHost;
